module.exports = __webpack_public_path__ + "fonts/okta-buttons-sprite-001.36eadf174a4679a1a0f4672544e0e762.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/ui/button/okta-buttons-sprite-001.png
// module id = 794
// module chunks = 9